
import React from "react";
import { Input } from "./input";
import { cn } from "@/lib/utils";

interface DateInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> {
  onChange: (value: string) => void;
  value: string;
}

export const DateInput = React.forwardRef<HTMLInputElement, DateInputProps>(
  ({ className, onChange, value, ...props }, ref) => {
    // Fonction pour formater la valeur entrée avec des barres obliques
    const formatDateString = (input: string): string => {
      // Supprimer tous les caractères non numériques
      const digitsOnly = input.replace(/\D/g, "");
      
      // Appliquer le format JJ/MM/AAAA
      let formatted = "";
      for (let i = 0; i < digitsOnly.length && i < 8; i++) {
        if (i === 2 || i === 4) {
          formatted += "/" + digitsOnly[i];
        } else {
          formatted += digitsOnly[i];
        }
      }
      
      // Gérer les cas spéciaux (si l'utilisateur supprime un caractère après un séparateur)
      if (digitsOnly.length === 2 && value.length === 3 && !value.endsWith("/")) {
        formatted = digitsOnly;
      } else if (digitsOnly.length === 4 && value.length === 6 && !value.endsWith("/")) {
        formatted = digitsOnly.substring(0, 2) + "/" + digitsOnly.substring(2);
      }
      
      return formatted;
    };

    // Gérer le changement de valeur
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const rawValue = e.target.value;
      const formattedValue = formatDateString(rawValue);
      onChange(formattedValue);
    };

    return (
      <Input
        ref={ref}
        type="text"
        className={cn(className)}
        value={value}
        onChange={handleChange}
        placeholder="JJ/MM/AAAA"
        maxLength={10}
        {...props}
      />
    );
  }
);

DateInput.displayName = "DateInput";
